import Grid from "@material-ui/core/Grid";
import React, {useEffect, useState} from "react";
import {DeleteRequestOfferPost, GetRequestOfferList, UpdateRequestOffer} from "../../redux/RequestOffer/actions";
import {connect, useSelector} from "react-redux";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TablePagination from "@material-ui/core/TablePagination";
import {makeStyles} from "@material-ui/core/styles";
import {RootState} from "../../redux/store";
import {Chip, Table} from "@material-ui/core";
import {useCookies} from "react-cookie";
import {useHistory} from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {Routes} from "../../constants";
import {ENV} from "../../utils/constants";
import style from './Styles.module.scss'
import moment from "moment";
import {CommonDispatcher, OpenModal} from "../../redux/Common/action";
import {OPEN_REQUEST_OFFER_MODAL, TOGGLE_CHANGE_OWNERSHIP_MODAL} from "../../redux/ModalReducer/actionTypes";
import {SHOW_SNACKBAR} from "../../redux/Common/actionTypes";
import {stripHtmlWithoutTags} from "../../utils/common";
import TableHeaderFilter from "../Common/TableHeaderFilter";

const useStyles = makeStyles({
    root: {
        width: "100%",
        height: "100%"
    },
    container: {
        maxHeight: "calc( 100vh - 220px)",
        minHeight: "calc( 100vh - 220px)"
    }
});

const options = [
    {title: "Edit", value: "edit"},
    {title: "Profile", value: "profile"},
    {title: "Delete the ad", value: "delete"},
    {title: "Request / Offer Profile", value: "request_offer_profile"},
    {title: "Change ownership", value: "changeOwnership"}
];

const ITEM_HEIGHT = 48;
const RequestOffer = ({OpenModal, UpdateRequestOffer, CommonDispatcher, GetRequestOfferList, DeleteRequestOfferPost}) => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const tableHeader = useSelector((store: RootState) => store?.requestOffer.tableHeader || []);
    const listingsData = useSelector((store: RootState) => store?.requestOffer.listingsData);
    const categories = useSelector((store: RootState) => store?.commonAppData?.categories?.requestOffer) || [];
    const [page, setPage] = useState((listingsData?.current_page || 1) - 1);
    const rowsPerPage = 30;
    const history = useHistory();
    const [cookies] = useCookies(["token"]);
    const token = cookies["token"];
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>, user) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setSelectedUser(user);
    };

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    useEffect(() => {
        const index = history?.location?.search.indexOf("=");
        const query = new URLSearchParams(history?.location?.search);
        const keyword = query.get('keyword');
        if (keyword) {
            getData({keyword});
        } else {
            const pageNo = parseInt(history?.location?.search.substr(index + 1));
            if (pageNo) {
                getData({page_number: pageNo});
                setPage(pageNo - 1);
            } else {
                getData({page_number: 1});
            }
        }
        // eslint-disable-next-line
    }, [history?.location?.search]);

    const getData = (data) => {
        setIsLoading(true);
        GetRequestOfferList(token, data).then(() => {
            setIsLoading(false);
        });
    };

    const appendPageNumber = (pageNumber) => {
        history.push({
            pathname: Routes.requestOffer,
            search: `?page=${pageNumber}`
        });
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        appendPageNumber(newPage + 1);
    };

    const renderRequestOffer = () => {
        GetRequestOfferList(token, {current_page: listingsData?.current_page}).then(() => {
            OpenModal(TOGGLE_CHANGE_OWNERSHIP_MODAL, {isOpen: false, isLoading: false});
            CommonDispatcher(SHOW_SNACKBAR, {
                isShowing: true,
                message: "Ownership changed successfully"
            });
        });
    };

    const handleChange = (value, selectedUser) => {
        console.log(selectedUser?.post)
        switch (value) {
            case "edit":
                OpenModal(OPEN_REQUEST_OFFER_MODAL, {
                    isOpen: true,
                    title: "Update a Request / Offer post",
                    config: {disableBackdropClick: true},
                    data: {
                        maxLimit: 1,
                        categories,
                        post: selectedUser?.post
                    },
                    callBack: () => {
                        OpenModal(OPEN_REQUEST_OFFER_MODAL, {isOpen: false});
                    }
                });
                break;
            case "profile":
                if (selectedUser?.user_name) {
                    const url = ENV === "DEVELOPMENT" ? `https://www.timexyz.com/${selectedUser?.user_name}` :
                        `https://www.luxembourgexpats.lu/${selectedUser?.user_name}`;
                    window.open(url, "_blank");
                } else {
                    alert("User details not available.")
                }
                break;
            case "delete":
                if (window?.confirm("Are you sure you want to delete this post?")) {
                    DeleteRequestOfferPost(token, selectedUser?.request_offer_id).then(() => getData({page_number: page})).catch(() => {
                        alert("Something went wrong.");
                    });
                }
                break;
            case "changeOwnership":
                OpenModal(TOGGLE_CHANGE_OWNERSHIP_MODAL, {
                    isOpen: true,
                    title: "Change ownership",
                    submitTitle: "Change",
                    data: {
                        modalSize: "xs",
                        disableBackdropClick: true,
                        owner_email: selectedUser?.owner_email
                    },
                    callBack: (flag, user_id) => {
                        if (flag) {
                            OpenModal(TOGGLE_CHANGE_OWNERSHIP_MODAL, {
                                isOpen: true,
                                isLoading: true,
                                title: "Change ownership",
                                submitTitle: "Change",
                                data: {
                                    modalSize: "xs",
                                    disableBackdropClick: true,
                                    owner_email: selectedUser?.owner_email
                                }
                            });
                            UpdateRequestOffer(token, {
                                request_offer_id: selectedUser?.request_offer_id,
                                user_id
                            }).then((d) => {
                                console.log(d);
                                if (d?.type === "success") {
                                    renderRequestOffer();
                                } else if (d?.type === "failed") {
                                    OpenModal(TOGGLE_CHANGE_OWNERSHIP_MODAL, {
                                        isOpen: true, isLoading: false
                                    });
                                    CommonDispatcher(SHOW_SNACKBAR, {
                                        isShowing: true,
                                        message: "Failed to change ownership"
                                    });
                                }
                            }).catch(() => {
                                OpenModal(TOGGLE_CHANGE_OWNERSHIP_MODAL, {
                                    isOpen: false, isLoading: false
                                });
                                CommonDispatcher(SHOW_SNACKBAR, {
                                    isShowing: true,
                                    message: "Failed to change ownership"
                                });
                            });
                        }
                    }
                });
                break;
            case "request_offer_profile": {
                if (selectedUser?.request_offer_id) {
                    const url = ENV === "DEVELOPMENT" ? `https://www.timexyz.com${Routes.requestOffer}/post/${selectedUser?.request_offer_id}` :
                        `https://www.luxembourgexpats.lu${Routes.requestOffer}/post/${selectedUser?.request_offer_id}`;
                    window.open(url, "_blank");
                } else {
                    alert("User details not available.")
                }
                break;
            }
        }
    };

    const renderMenu = (post) => {
        const {request_offer_id, email: owner_email, user_name} = post;
        return <>
            <IconButton aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={e => handleClick(e, {request_offer_id, owner_email, user_name, post})}>
                <MoreVertIcon/>
            </IconButton>
            <Menu id="long-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={open}
                  onClose={handleClose}
                  classes={{paper: `${style.menu} border2px w-auto`}}
                  PaperProps={{
                      style: {
                          maxHeight: ITEM_HEIGHT * 4.5,
                          width: "20ch"
                      }
                  }}>
                {options.map((option, i) => (
                    <MenuItem key={option?.value}
                              onClick={() => {
                                  handleChange(option?.value, selectedUser);
                                  setAnchorEl(null);
                              }}>
                        {option?.title}
                    </MenuItem>
                ))}
            </Menu>
        </>;
    };

    return <Grid container spacing={0} className="h-100">
        <Grid item xs={12}>
            <Paper className={classes.root}>
                <TableHeaderFilter sectionBaseUrl={Routes.requestOffer}/>
                {isLoading ? <div className="mainLoader">
                    <div className="loader"/>
                </div> : <>
                    <TableContainer className={classes.container}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {tableHeader?.map((column) => (
                                        <TableCell key={column.id}>
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listingsData?.posts.length ? listingsData?.posts?.map(row => {
                                        const interests = row?.interests && row?.interests.length ? row?.interests.map(d => d.interest_id) : []
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row?.request_offer_id}
                                                      style={{padding: 0, cursor: "pointer"}}
                                                      onClick={(e) => {
                                                          // history.push(`${Routes.requestOffer}/${row?.user_id}`);
                                                      }}>
                                                <TableCell size={"small"} onClick={e => e.stopPropagation()}>
                                                    {renderMenu(row)}
                                                </TableCell>
                                                <TableCell style={{minWidth: "180px"}}>
                                                    {row?.category_id ?
                                                        categories.map((c, i) => {
                                                            return row?.category_id === c?.value &&
																<span className="colorBlue" key={i}>
                                                                    {c?.title}
                                                                </span>
                                                        }) : null}
                                                </TableCell>
                                                <TableCell size={"small"}>
                                                    <Chip size="small"
                                                          label={row?.type}
                                                          color={row?.type === 'REQUEST' ? "primary" : "secondary"}/>
                                                </TableCell>
                                                <TableCell style={{minWidth: "250px"}} size={"small"}
                                                           className="py-5">
                                                    {stripHtmlWithoutTags(row?.description)}
                                                </TableCell>
                                                <TableCell size={"small"} style={{minWidth: "70px"}}>
                                                    <Chip size="small"
                                                          label={row?.is_online ? "Yes" : "No"}
                                                          color={row?.is_online ? "primary" : "secondary"}/>
                                                </TableCell>
                                                <TableCell size={"small"} style={{minWidth: "70px"}}>
                                                    <Chip size="small"
                                                          label={row?.is_in_person ? "Yes" : "No"}
                                                          color={row?.is_in_person ? "primary" : "secondary"}/>
                                                </TableCell>
                                                <TableCell size={"small"} style={{minWidth: "70px"}}>
                                                    <Chip size="small"
                                                          label={row?.is_free ? "Yes" : "No"}
                                                          color={row?.is_free ? "primary" : "secondary"}/>
                                                </TableCell>
                                                <TableCell style={{minWidth: "100px"}} size={"small"}>
                                                    {row?.is_free ? <Chip size="small"
                                                                          label={row?.is_free ? "Free" : ""}
                                                                          color={row?.is_free ? "primary" : "secondary"}/> : row?.display_price || 'N/A'}
                                                </TableCell>
                                                <TableCell style={{minWidth: "100px"}} size={"small"}>
                                                    {row?.start_date ? moment(row?.start_date).format("DD MMM, YYYY") : 'N/A'}
                                                </TableCell>
                                                <TableCell style={{minWidth: "100px"}} size={"small"}>
                                                    {row?.end_date ? moment(row?.end_date).format("DD MMM, YYYY") : 'N/A'}
                                                </TableCell>
                                                <TableCell style={{minWidth: "100px"}} size={"small"}>
                                                    {row?.posted_on ? moment(row?.posted_on).format("DD MMM, YYYY") : 'N/A'}
                                                </TableCell>
                                                <TableCell size={"small"}>
                                                    {row?.full_name}
                                                </TableCell>
                                                <TableCell size={"small"}>
                                                    {row?.email}
                                                </TableCell>
                                                <TableCell size={"small"}
                                                           onClick={e => e.stopPropagation()}>
                                                    <Chip size="small"
                                                          label={row?.status === "LIVE" ? "Deactivate" : "Activate"}
                                                          clickable
                                                          color={row?.status === "LIVE" ? "secondary" : "primary"}/>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }) :
                                    <tr>
                                        <td colSpan={tableHeader.length + 1} className="dataNotAvailable">
                                            Data not available
                                        </td>
                                    </tr>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination hidden={!listingsData?.posts.length}
                                     rowsPerPageOptions={[]}
                                     component="div"
                                     count={listingsData?.count}
                                     rowsPerPage={rowsPerPage}
                                     page={page}
                                     onChangePage={handleChangePage}/>
                </>}
            </Paper>
        </Grid>
    </Grid>;
};
export default connect(null, {
    OpenModal,
    CommonDispatcher,
    GetRequestOfferList,
    UpdateRequestOffer,
    DeleteRequestOfferPost,
})(RequestOffer);